import { render } from "./MetadataSelection.vue?vue&type=template&id=305883fa&scoped=true"
import script from "./MetadataSelection.vue?vue&type=script&lang=js"
export * from "./MetadataSelection.vue?vue&type=script&lang=js"

import "./MetadataSelection.vue?vue&type=style&index=0&id=305883fa&lang=scss&scoped=true"

import exportComponent from "/Users/klaus/Projects/sfdc-happy-soup/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305883fa"]])

export default __exports__